const onlyDigitsAndLatinLetters = (string = '') => string
  .replace(/[^a-zA-Z0-9]+/g, '');
export default onlyDigitsAndLatinLetters;